import React, { useState } from "react";
import "../css/comites.css";
import image from "../img/ingenieria/Pablo Campoverde.jpg";

const organizador = [
  {
    nombre: "Ph. D. Yasmany García Ramírez",
    cargo: "Coordinador",
    institucion: "Universidad Técnica Particular de Loja, Ecuador",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/Yasmany_Gacia.jpg",
  },
  {
    nombre: "Mgtr. Bolívar Maza",
    cargo: "",
    institucion: "Universidad Técnica Particular de Loja, Ecuador",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1102295761_low.jpg",
  },
  {
    nombre: "Mgtr. Pablo Campoverde",
    cargo: "",
    institucion: "Universidad Técnica Particular de Loja, Ecuador",
    foto: image,
  },
  {
    nombre: "Ph. D. José Guartán",
    cargo: "",
    institucion: "Universidad Técnica Particular de Loja, Ecuador",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1103034615_low.jpg",
  },
  {
    nombre: "Mgtr. Juan Carlos Guanín",
    cargo: "",
    institucion: "Universidad Técnica Particular de Loja, Ecuador",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1102951660_low.jpg",
  },
];

const otrosComites = [
  {
    titulo: "Comité Científico Internacional",
    miembros: [
      "Ph. D. Henrry Rojas (CHI)",
      "Ph. D. Edwin Duque (ECU)",
      "Mgtr. Fabián Díaz (ECU)",
      "Mgtr. Javier Vásquez (ECU)",
      "Ph. D. Belizario Zárate",
      "Mgtr. Vinicio Roblez",
      "Mgtr. Juan Carlos Palacios",
      "Ph. D. José Luis Chávez",
    ],

  },
];

export default function Comites() {
  const [activo, setActivo] = useState(null);

  const toggle = (index) => {
    setActivo(activo === index ? null : index);
  };

  return (
    <div className="comites-container">
      {/* Comité Organizador */}
      <h2 className="titulo-seccion">
        Comité <b> Organizador</b>
      </h2>

      <div className="organizador-grid">
        {organizador.map((persona, i) => (
          <div key={i} className="persona-card">
            <img src={persona.foto} alt={persona.nombre} />
            <h3>{persona.nombre}</h3>
            <p className="cargo">{persona.cargo}</p>
            <p className="inst">{persona.institucion}</p>
          </div>
        ))}
      </div>

      {/* Acordeones */}
      <div className="acordeones layout6">
        {otrosComites.map((comite, index) => (
          <div key={index} className="acordeon">
            <button className="acordeon-header" onClick={() => toggle(index)}>
              {comite.titulo}
              <span>{activo === index ? "-" : "+"}</span>
            </button>

            <div
              className={`acordeon-body ${activo === index ? "activo" : ""}`}
            >
              <ul>
                {comite.miembros.map((m, i) => (
                  <li key={i}><p> {m}</p></li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
